<template>
	<section id="about" class="bg-primary cover scroll d-flex align-items-center">
		<b-container class="py-5 py-md-3 py-lg-5">
			<b-row class="py-3">
				<b-col cols="12" lg="6">
						<h2 class="text-white text-uppercase font-weight-bold pb-3 pb-md-0 pb-lg-3">Det här är Lidl</h2>
						<hr class="border-white bold w-5 d-inline-block"/>
						<p class="text-white font-weight-bold m-0">Störst inom dagligvaruhandel i Europa</p>
						<p class="text-white">Lidl Sverige är dotterbolag till Lidl Stiftung & Co. och del i företagsgruppen Schwarz, Europas största och världens fjärde största företag inom dagligvaruhandel. Till Schwarz-gruppen hör bland andra även Kaufland.</p>
						<p class="text-white font-weight-bold m-0 pt-3">Stolt utmanare i Sverige</p>
						<p class="text-white">Lidl kom till Sverige 2003 och har sedan dess utmanat marknaden med kvalitetsvaror till riktigt bra priser. Idag har vi över 180 butiker och drygt 4 200 medarbetare. Målet är 200 butiker år 2020 och 300 på sikt.</p>
						<a :href="$creo.browserPdfLink(pdfLink.org, pdfLink.fallback, pdfLink.page)" target="_blank" class="font-weight-bold text-secondary pb-4 pb-lg-0 pt-5 pt-md-3 pt-lg-5 text-center text-uppercase d-block">Läs mer</a>
					</scroll-view>
				</b-col>
				<b-col cols="10" sm="8" class="mx-auto d-lg-none pt-5 text-center">
					<img src="../assets/img/map_mob.svg" width="382" height="536" alt="Över 108 butiker, över 4200 medarbetare" class="img-fluid d-inline-block">
				</b-col>
			</b-row>
		</b-container>
	</section>
</template>
<script>
	export default {
		name: 'About',
		props: {
			pdfLink: {
				default: null
			}
		},
		created() {
			this.$root.$on('bv::scrollspy::activate', this.onActivate)
		},
		methods: {
			onActivate(target) {
				const container = document.getElementById('about');
				if(target === '#about') {
					container.classList.add('about');
				}
			}
		}
	}
</script>
